<template>
  <div class="job-position">
    <div v-if="$props.position.name" class="text-center">
      <h2>{{ $props.position.name }}</h2>
    </div>
    <div class="job-position-company flex">
      <div v-if="$props.position.logotype" class="job-position-company-image flex">
        <div
          :class="[
            'job-position-company-image-container flex',
            { [$props.position.backgroundColor]: $props.position.backgroundColor }
          ]"
        >
          <img
            :src="$props.position.logotype"
            :alt="$t('aboutMe.altLabel', { element: $props.position.company })"
            class="job-position-company-image-container-tag"
          />
        </div>
      </div>
      <div class="job-position-company-title text-center text-sm-left">
        <div
          v-if="$props.position.href && $props.position.company"
          class="job-position-company-title-text"
        >
          <a
            v-if="$props.position.href"
            :href="$props.position.href"
            class="general-anchor decorated"
            target="_blank"
            rel="noreferrer,noopener"
          >
            <h3 class="job-position-company-title-text-tag">
              <span>{{ $props.position.company }}</span>
            </h3>
          </a>
          <h3 v-else class="job-position-company-container-title">{{ $props.position.company }}</h3>
        </div>
        <div v-if="$props.position.date" class="job-position-company-title-text text-lg-right">
          <h3 class="job-position-company-title-text-tag">{{ $props.position.date }}</h3>
        </div>
      </div>
    </div>
    <div
      v-if="$props.position.activities && $props.position.activities.length"
      class="job-position-activities"
    >
      <h4 class="job-position-activities-title">
        {{ $t("aboutMe.workExperience.activitiesLabel") }}
      </h4>
      <ul class="job-position-activities-list">
        <li
          v-for="(activity, i) in $props.position.activities"
          :key="`${$props.position.href}${i}`"
        >
          {{ activity }}
        </li>
      </ul>
    </div>
    <div
      v-if="$props.position.technologies && $props.position.technologies.length"
      class="job-position-technologies"
    >
      <h4 class="job-position-technologies-title">
        {{ $t("aboutMe.workExperience.technologiesLabel") }}
      </h4>
      <listed-technologies :elements="$props.position.technologies" />
    </div>
  </div>
</template>

<script>
const ListedTechnologies = () =>
  import(
    /* webpackChunkName: "WorkExperiencePage" */ "@/components/AboutMe/JobPosition/ListedTechnologies"
  );

export default {
  name: "JobPosition",
  components: {
    ListedTechnologies
  },
  props: {
    /*
     * @property - position
     * Defines all content inside this component
     * $position.name
     * $position.company
     * $position.href
     * $position.logotype
     * $position.backgroundColor
     * $position.date
     * $position.activities
     * $position.technologies
     */
    position: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.job-position {
  border-top: 0.0625rem solid $main-green;
  padding: 1.5rem 0 3rem 0;

  &-company {
    flex-wrap: wrap;

    &-image {
      width: 100%;

      @include breakpoint($small) {
        flex: 0 0;
      }

      &-container {
        @include boxShadow(0.25, true, false);
        background-color: $white-raw;
        border: 0.0625rem solid $main-blue;
        border-radius: 0.45rem;
        height: 6.5rem;
        margin: auto;
        overflow: hidden;
        width: 6.5rem;

        &.black {
          background-color: $dark-gray;
          border: 0.0625rem solid $main-green;
        }

        &-tag {
          margin: auto;
          max-height: 95%;
          max-width: 95%;
        }
      }
    }

    &-title {
      width: 100%;

      @include breakpoint($small) {
        flex: 1 0;
        max-width: 100%;
        padding-left: 1rem;
      }

      @include breakpoint($large) {
        display: flex;
        flex-wrap: wrap;
      }

      &-text {
        width: 100%;

        @include breakpoint($large) {
          flex: 1 0;
          max-width: 100%;
        }

        &-tag {
          display: inline-block;
          margin: 0.25rem 0;

          @include breakpoint($small) {
            margin: 0.85rem 0 0 0;
          }

          @include breakpoint($large) {
            margin: 1.65rem 0 0 0;
          }
        }
      }
    }
  }

  &-activities {
    &-title,
    &-list {
      margin: 0.65rem 0;
    }
  }

  &-technologies {
    &-title {
      margin: 0.65rem 0;
    }
  }
}
</style>
